import { EducationLevelType } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { Field } from 'modules/onboarding/common/forms/knowledgeAndExperienceForm';

export const EducationFields = () => {
  const { t } = useTranslation();

  return (
    <Field.Autocomplete
      label={t(
        `onboarding.knowledgeAndExperience.education.educationField.label`
      )}
      name="education.educationLevel"
      optionLabelKey="label"
      options={Object.values(EducationLevelType).map((v) => ({
        label: t(`onboarding.knowledgeAndExperience.education.types.${v}`),
        value: v,
      }))}
      optionValueKey="value"
      placeholder={t(
        `onboarding.knowledgeAndExperience.education.educationField.placeholder`
      )}
      variant="select"
    />
  );
};
